import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=c7650bb0&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=c7650bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7650bb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7650bb0')) {
      api.createRecord('c7650bb0', component.options)
    } else {
      api.reload('c7650bb0', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=c7650bb0&scoped=true&", function () {
      api.rerender('c7650bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eKj0yD3V9saX/JS/comp/GuestBoxKids.vue"
export default component.exports